import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PageHeaderProps {
    eyebrow?: ReactNode
    title: ReactNode
    description?: ReactNode
    actions?: ReactNode
    children?: ReactNode
    className?: string
}

const PageHeader = ({ eyebrow, title, description, actions, children, className }: PageHeaderProps): ReactNode => {
    return (
        <header className={cn('mb-6 flex flex-col gap-4 lg:mb-8', className)}>
            <div className='flex flex-wrap items-end justify-between gap-4'>
                <div className='min-w-0 max-w-3xl'>
                    {eyebrow && (
                        <p className='mb-2 text-xs font-medium uppercase tracking-[0.1em] text-primary'>
                            {eyebrow}
                        </p>
                    )}

                    <h1 className='font-heading text-2xl font-semibold tracking-tight text-foreground sm:text-3xl'>
                        {title}
                    </h1>

                    {description && (
                        <p className='mt-2 text-[15px] leading-relaxed text-muted-foreground'>
                            {description}
                        </p>
                    )}
                </div>

                {actions && <div className='flex flex-wrap items-center gap-2'>{actions}</div>}
            </div>

            {children}
        </header>
    )
}

export default PageHeader
